import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.459 14.125a2.25 2.25 0 0 1-2.25 2.25H3.792a2.25 2.25 0 0 1-2.25-2.25v-8.25a2.25 2.25 0 0 1 2.25-2.25h8.087c.596 0 1.169.237 1.59.658L17.8 8.61c.422.422.66.995.66 1.592zm-4.458-3.791a2.25 2.25 0 0 1-2.252-2.25V5.125H3.792a.75.75 0 0 0-.75.75v8.25c0 .414.336.75.75.75h12.417a.75.75 0 0 0 .75-.75v-3.793zm-2.643.291a.75.75 0 0 1-.75.75h-5.4a.75.75 0 0 1 0-1.5h5.4a.75.75 0 0 1 .75.75m-2.7 2.5a.75.75 0 0 1-.75.75h-2.7a.75.75 0 0 1 0-1.5h2.7a.75.75 0 0 1 .75.75m4.591-6.941v1.9c0 .414.337.75.751.75l1.9-.002z"
    }, null, -1)
  ]))]))
}
export default { render: render }